import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import AwsS3 from '@uppy/aws-s3';
import UserAjax from '@ajax/user';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

function setupUppy(fileInput, onSuccess, onProgress, options = {}) {
  var maxNumberOfFiles = options.maxNumberOfFiles || 999;
  var maxSize = options.maxSize || 20971520;
  var locale = options.locale || {};

  onSuccess = onSuccess || function () {};
  onProgress = onProgress || function () {};

  var uppy = new Uppy({
    id: 'uppy',
    autoProceed: true,
    restrictions: {
      allowedFileTypes: options['uploadTypes'] || ['image/*', 'video/*'],
      maxNumberOfFiles: maxNumberOfFiles,
      maxFileSize: maxSize,
    },
    locale: locale,
    onBeforeFileAdded: function (file) {
      file.meta = file.meta || {};
      file.meta.env = 'development';
      let response = true;

      if (options['beforeFileAdded']) {
        response = options['beforeFileAdded'](uppy, file);
      }

      return response;
    },
  })
    .use(AwsS3, {
      getUploadParameters: async (_file) => {
        const data = await UserAjax.presignedUrl();
        return {
          method: 'PUT',
          url: data.url,
          fields: {},
          headers: { 'cache-control': 'max-age=36000' },
        };
      },
    })
    .use(Dashboard, {
      trigger: fileInput,
      note: options['note'],
      proudlyDisplayPoweredByUppy: false,
      onRequestCloseModal: () => {
        uppy.getPlugin('Dashboard').closeModal();
      },
    });

  uppy.on('complete', function (_result) {
    if (uppy.getState().totalProgress >= 100) {
      uppy.getPlugin('Dashboard').closeModal();
      uppy.cancelAll();
    }
  });

  uppy.on('upload-success', function (file, response) {
    file.uploadURL = response.uploadURL;
    file.response = response;
    onSuccess([file], uppy);
  });

  uppy.on('upload-progress', function (file, progress) {
    var percentage = parseInt((progress.bytesUploaded / progress.bytesTotal) * 100);
    onProgress(percentage, file, progress);
  });

  return uppy;
}

export default {
  attach: function (fileInput, successFn, progressFn, options) {
    return setupUppy(fileInput, successFn, progressFn, options);
  },
};
